import { useLoader } from "@/context/loaderContext";

import { useToast } from "../toast";
import api from "@/components/customAxios/Axios";
import { useEffect, useState } from "react";
type QuickDataType = {
	total_assessments_completed: number;
	total_assessments_sent: number;
	total_cvs: number;
	total_job_descriptions: number;
	total_registered_users: number;
	total_unsent_candidates: number;
};
type dateRangeTypes = {
	date: {
		fromDate: string;
		toDate: string;
	};
};
const QuickData = ({ ...props }: dateRangeTypes) => {
	const [data, setData] = useState<QuickDataType | null>(null);
	const { setLoading } = useLoader();
	const toast = useToast();
	const getQuickData = async () => {
		try {
			setLoading(true);
			const response = await api.get("/dashboard/admin", {
				params: {
					fromDate: props.date.fromDate,
					toDate: props.date.toDate,
				},
			});

			setData(response.data.high_level_analytics);
		} catch (err: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Fetching Analytics Details",
				description: err.response?.data?.error || err.response?.data?.message || "Failed to fetch analytics details. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		if (props.date.fromDate > props.date.toDate) {
			alert(
				"Please select proper dates: 'From Date' should be earlier than or equal to 'To Date'."
			);
			return;
		}
		getQuickData();
	}, [props.date]);
	const formatedData = [
		{
			title: "Registered User",
			count: data?.total_registered_users,
			icon: (
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
						stroke="#FAB915"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
						stroke="#FAB915"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M19 8V14"
						stroke="#FAB915"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M22 11H16"
						stroke="#FAB915"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},
		{
			title: "Jobs",
			count: data?.total_job_descriptions,
			icon: (
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16 20V4C16 3.46957 15.7893 2.96086 15.4142 2.58579C15.0391 2.21071 14.5304 2 14 2H10C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4V20"
						stroke="#F87171"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M20 6H4C2.89543 6 2 6.89543 2 8V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8C22 6.89543 21.1046 6 20 6Z"
						stroke="#F87171"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},
		{
			title: "Screened Candidates",
			count: data?.total_cvs,
			icon: (
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
						stroke="#A979DD"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
						stroke="#A979DD"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M22 21V19C21.9993 18.1137 21.7044 17.2528 21.1614 16.5523C20.6184 15.8519 19.8581 15.3516 19 15.13"
						stroke="#A979DD"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
						stroke="#A979DD"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},

		{
			title: "Unsent Assessments",
			count: (data?.total_cvs || 0) - (data?.total_assessments_sent || 0),
			icon: (
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M18 18C19.6569 18 21 16.6569 21 15C21 13.3431 19.6569 12 18 12C16.3431 12 15 13.3431 15 15C15 16.6569 16.3431 18 18 18Z"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M10 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M21.7 16.4L20.8 16.1"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M15.2 13.9L14.3 13.6"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M16.6 18.7L16.9 17.8"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M19.1 12.2L19.4 11.3"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M19.6 18.7L19.2 17.7"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M16.8 12.3L16.4 11.3"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M14.3 16.6L15.3 16.2"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M20.7 13.8L21.7 13.4"
						stroke="#8497DE"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},

		{
			title: "Assessments Sent",
			count: data?.total_assessments_sent,
			icon: (
				<svg
					width="22"
					height="22"
					viewBox="0 0 22 22"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M19.25 13.75C19.25 14.2362 19.0568 14.7025 18.713 15.0464C18.3692 15.3902 17.9029 15.5833 17.4167 15.5833H6.41667L2.75 19.25V4.58333C2.75 4.0971 2.94315 3.63079 3.28697 3.28697C3.63079 2.94315 4.0971 2.75 4.58333 2.75H17.4167C17.9029 2.75 18.3692 2.94315 18.713 3.28697C19.0568 3.63079 19.25 4.0971 19.25 4.58333V13.75Z"
						stroke="#49BCA4"
						strokeWidth="1.66667"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},
		{
			title: "Assessments Completed	",
			count: data?.total_assessments_completed,
			icon: (
				<svg
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21"
						stroke="#F0AA4C"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
						stroke="#F0AA4C"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M16 11L18 13L22 9"
						stroke="#F0AA4C"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			),
		},
	];
	const iconColor = [
		"bg-[#FEF9C3]",
		"bg-[#FEE2E2]",
		"bg-[#EFE0FF] ",
		"bg-[#D5DEFF]",
		"bg-[#CCFBF1]",
		"bg-[#FFEDD5]",
	];
	return (
		<div>
			<div className="grid  grid-cols-2 md:grid-cols-3  gap-x-3 gap-y-4">
				{formatedData.map((item, index) => (
					<div
						// data-aos="zoom-in"
						key={index}
						className="flex items-center gap-3 bg-white p-3.5 rounded-lg  hover:shadow-lg transition-all hover:scale-105 w-full "
					>
						<div
							className={`${iconColor[index]} p-2.5 rounded-full  flex items-center justify-center relative `}
						>
							{item.icon}
						</div>

						{/* Text */}
						<div className=" relative text-sm">
							<p className=" text-gray-600 font-body">
								{item.title.split(" ")[0]} <br />{" "}
								{item.title.split(" ").slice(1).join(" ")}
							</p>
							<p className="text-lg font-semibold text-gray-800 font-subheading">
								{item.count || 0}
							</p>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default QuickData;
